export function getPreferredLang(): string {
  const preferredLang = localStorage.getItem("pref-lang") || "en";

  return preferredLang;
}
